import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent } from "@/components/ui/card";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";

export const NewsSkeleton: React.FC = () => {
  return (
    <MainPageWrapper
      subtitle="Latest updates and insights from across the trades"
      title="News"
    >
      <div className="space-y-6">
        {/* Search Bar Skeleton */}
        <Skeleton className="h-10 w-full" />

        {/* Trade Filters Skeleton */}
        <div className="flex gap-2">
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-8 w-24" />
          <Skeleton className="h-8 w-28" />
          <Skeleton className="h-8 w-24" />
        </div>

        {/* News Grid Skeleton */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {[...Array(6)].map((_, index) => (
            <Card className="h-full" key={index}>
              {/* Image Skeleton */}
              <Skeleton className="aspect-video w-full rounded-t-lg" />

              <CardContent className="p-6">
                {/* Date Skeleton */}
                <Skeleton className="h-3 w-24 mb-3" />

                {/* Title Skeleton */}
                <Skeleton className="h-6 w-full mb-2" />
                <Skeleton className="h-6 w-3/4 mb-3" />

                {/* Description Skeleton */}
                <Skeleton className="h-4 w-full mb-2" />
                <Skeleton className="h-4 w-full mb-2" />
                <Skeleton className="h-4 w-2/3 mb-4" />

                {/* Tags Skeleton */}
                <div className="flex gap-2">
                  <Skeleton className="h-5 w-16 rounded-full" />
                  <Skeleton className="h-5 w-20 rounded-full" />
                  <Skeleton className="h-5 w-18 rounded-full" />
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </MainPageWrapper>
  );
};
